var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = !_vm.loadding
    ? _vm.__map(_vm.tableData, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g0 = item.image_list.length
        return {
          $orig: $orig,
          g0: g0,
        }
      })
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }